import { createContext } from 'react';

export interface IErrorContext {
  error: Error | null;
  setError: (error: Error | null) => void;
}

export const ErrorContext = createContext({} as IErrorContext);
